<template>
  <div class="container">
    <form @submit.prevent="login" class="form-login">
      <h2>Insider</h2>
      <div class="form-group">
        <label for="username">User name</label>
        <input v-model="username" id="username" class="form-control" required v-focus>
      </div>
      <div class="form-group">
        <label for="password">Password</label>
        <input v-model="password" id="password" type="password" class="form-control" required>
      </div>
      <b-button type="submit" variant="primary">Log in</b-button>
    </form>
  </div>
</template>

<script>
import auth from '../auth';
import notifier from '../notifier';

export default {
  data() {
    return {
      username: '',
      password: '',
    };
  },

  methods: {
    login() {
      notifier.deleteSenderNotifications(this);

      auth.login(
        this.username,
        this.password,
        onLoginResponse.bind(this),
      );

      function onLoginResponse(loggedIn, err) {
        if(err !== null) {
          notifier.showError(err.response.data, {sender: this});
          return;
        }

        if(!loggedIn) {
          notifier.showError('Invalid user name or password.', {sender: this});
          return;
        }

        this.$router.push({name: 'home'});
      }
    }
  }
}
</script>

<style scoped>
.form-login {
  max-width: 330px;
  margin: 4em auto 0em;
}
</style>
